import { render, staticRenderFns } from "./openWindowPanel.vue?vue&type=template&id=1fbefe4a&scoped=true"
import script from "./openWindowPanel.vue?vue&type=script&lang=js"
export * from "./openWindowPanel.vue?vue&type=script&lang=js"
import style0 from "./openWindowPanel.vue?vue&type=style&index=0&id=1fbefe4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbefe4a",
  null
  
)

export default component.exports